import { memo } from "react";

import styles from "./style.module.scss";

export type LoaderProps = {
  columns?: number,
  rows?: number,
}

const Loader = memo<LoaderProps>(({ columns, rows = 10 }) => {
  const renderRows = () => [ ...new Array(rows) ].map((row, rowIndex) =>
    <div
      key={rowIndex}
      className={styles.row}
    >
      {[ ...new Array(columns) ].map((col, colIndex) =>
        <div
          key={`${rowIndex}-${colIndex}`}
          className={styles.cell}
        >
          <div className={styles.innerCell} />
        </div>,
      )}
    </div>,
  );

  return (

    <div className={styles.root}>
      <div className={styles.loader}>
        <div className={styles.loaderOverlay} />
      </div>
      <div className={styles.rowsContainer}>
        {renderRows()}
      </div>
      {renderRows()}
    </div>
  );
});

export default Loader;
